import { TSelectOption } from "@minuthq/meatball-ui-react"

import { TParadiseLLMPromptCategory } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"

export const paradiseLLMPromptCategorySelectOptions: TSelectOption<TParadiseLLMPromptCategory>[] =
  [
    {
      value: "guest_message_input_sanitization",
      label: "Guest Message Input Sanitization",
    },
    { value: "guest_message_response", label: "Guest Message Response" },
    {
      value: "guest_message_output_sanitization",
      label: "Guest Message Output Sanitization",
    },
  ]
